// bytesToSize
// https://gist.github.com/lanqy/5193417
var SIZES = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
var KILOBYTE_IN_BYTES = 1024;
export default function bytesToSize(value) {
  var bytes = Number(value);
  if (bytes === 0 || Number.isNaN(bytes)) return 'n/a';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(KILOBYTE_IN_BYTES)), 10);
  if (i === 0) return "".concat(bytes, " ").concat(SIZES[i]);
  return "".concat((bytes / Math.pow(KILOBYTE_IN_BYTES, i)).toFixed(1), " ").concat(SIZES[i]);
}